define('DateCalculations.Compare', ['DateCalculations.Moments'], function DateCalculationsCompare(
  DateCalculationsMoments
) {
  'use strict';

  return {
    /**
     * @param {number|null} shippingTime1
     * @param {number|null} shippingTime2
     * @returns {number}
     */
    compareShippingTimes: function compareShippingTimes(shippingTime1, shippingTime2) {
      var isNumber1 = typeof shippingTime1 === 'number';
      var isNumber2 = typeof shippingTime2 === 'number';
      if (isNumber1 && isNumber2) {
        if (shippingTime1 < shippingTime2) {
          return -1;
        }
        if (shippingTime1 === shippingTime2) {
          return 0;
        }
        return 1;
      }
      if (!isNumber1 && !isNumber2) {
        return 0;
      }
      if (isNumber1) {
        return -1;
      }
      if (isNumber2) {
        return 1;
      }
      return 0;
    },

    compareTimeOfDayToday: function compareTimeOfDayToday(timeData1, timeData2) {
      var moment1 = DateCalculationsMoments.getMomentForTimeToday(timeData1);
      var moment2 = DateCalculationsMoments.getMomentForTimeToday(timeData2);
      if (moment1 && moment2) {
        if (moment1.isBefore(moment2)) {
          return 1;
        }
        if (moment1.isSame(moment2)) {
          return 0;
        }
        return -1;
      }
      if (!moment1) {
        return 1;
      }
      if (!moment2) {
        return -1;
      }
      return 0;
    }
  };
});
